import React from "react";
import { Link } from "react-router-dom";
import { usageBar } from "../lib/useUsage";
import { ArrowUpRight } from "@phosphor-icons/react";

function Row({ label, current, limit, testid }) {
  const s = usageBar(current, limit);
  const color = s.over ? "var(--accent)" : s.near ? "#F59E0B" : "var(--text)";
  return (
    <div className="p-4 border-b last:border-b-0" style={{ borderColor: "var(--border)" }} data-testid={testid}>
      <div className="flex items-center justify-between text-sm">
        <span style={{ color: "var(--text-2)" }}>{label}</span>
        <span className="font-mono font-semibold" style={{ color }}>
          {s.unlimited ? `${current} · unlimited` : `${current} / ${limit}`}
        </span>
      </div>
      <div className="mt-2 h-1.5" style={{ background: "var(--surface-2)" }}>
        <div
          className="h-full transition-all"
          style={{ width: s.unlimited ? "100%" : `${s.pct}%`, background: color, opacity: s.unlimited ? 0.3 : 1 }}
        />
      </div>
    </div>
  );
}

export default function UsageWidget({ usage }) {
  if (!usage) return null;
  const { plan_label, limits, usage: u } = usage;
  return (
    <div className="border" style={{ borderColor: "var(--border)" }} data-testid="usage-widget">
      <div className="p-4 border-b flex items-center justify-between" style={{ borderColor: "var(--border)" }}>
        <div>
          <div className="overline">// current plan</div>
          <div className="font-display font-black text-xl tracking-tighter mt-1">{plan_label}</div>
        </div>
        <Link to="/book-a-call" data-testid="usage-upgrade-link" className="text-xs uppercase tracking-widest font-mono flex items-center gap-1 hover:text-white" style={{ color: "var(--accent)" }}>
          upgrade <ArrowUpRight weight="bold" />
        </Link>
      </div>
      <Row label="Contacts" current={u.contacts} limit={limits.contacts} testid="usage-contacts" />
      <Row label="Card scans / month" current={u.scans} limit={limits.scans} testid="usage-scans" />
      <Row label="Emails / month" current={u.emails} limit={limits.emails} testid="usage-emails" />
    </div>
  );
}
